/** Inline alert tone. */
export type AlertVariant = "info" | "success" | "warning" | "error";

/**
 * Inline message with variant styling and appropriate **`role`**.
 *
 * @param options - Variant, optional title, and body copy (catalog-backed).
 * @returns **`div`** with **`qz-alert`** classes.
 */
export function createAlert(
  options: Readonly<{
    variant: AlertVariant;
    title?: string;
    body: string;
  }>,
): HTMLDivElement {
  const root = document.createElement("div");
  root.className = `qz-alert qz-alert--${options.variant}`;
  const useAlertRole =
    options.variant === "error" || options.variant === "warning";
  root.setAttribute("role", useAlertRole ? "alert" : "status");

  if (options.title !== undefined && options.title.length > 0) {
    const t = document.createElement("p");
    t.className = "qz-alert__title";
    t.textContent = options.title;
    root.appendChild(t);
  }

  const b = document.createElement("p");
  b.className = "qz-alert__body";
  b.textContent = options.body;
  root.appendChild(b);

  return root;
}
